import { Layout } from '@design-systems/canvas-ui'
import { SideNavigation } from 'layout/sidenav/SideNavigation'
import LogoSlot from './LogoSlot'
import { ActionSlot } from './ActionSlot'
import { ProfileSlot } from './ProfileSlot'
import { GlobalSearchSlot } from './globalSearch/components/globalSearchSlot/GlobalSearchSlot'
import { useContext } from 'react'
import { UserContext } from './UserContext'
import { PartnerTypeToaster } from 'account/components/PartnerTypeToaster'
import type { LayoutProps } from '@design-systems/canvas-ui'
import AppBanner from './AppBanner'
import BasicErrorBoundary from './BasicErrorBoundary'

type DarkModeSetting = LayoutProps['darkMode']

const themeToDarkMode = (theme: string | undefined): DarkModeSetting => {
  if (theme === 'DARK') return true
  if (theme === 'LIGHT') return false
  return 'system'
}

type AppLayoutProps = { children?: React.ReactNode }

const canvasV7DarkMode = 'C-Theme--default C-Layout C-Mode--dark'
const canvasV7LightMode = 'C-Theme--default C-Layout C-Mode--light'

export const AppLayout = (props: AppLayoutProps) => {
  const { children } = props
  const { sparkUser, isDark } = useContext(UserContext)
  const darkMode = themeToDarkMode(sparkUser?.theme)
  return (
    <Layout
      darkMode={darkMode}
      className={isDark ? canvasV7DarkMode : canvasV7LightMode}
    >
      <PartnerTypeToaster />
      <Layout.GlobalHeader
        logoSlot={<LogoSlot />}
        searchSlot={<GlobalSearchSlot />}
        actionsSlot={<ActionSlot />}
        profileSlot={<ProfileSlot />}
      />
      <AppBanner />
      <SideNavigation />
      <Layout.Body>
        <BasicErrorBoundary name="AppLayout">{children}</BasicErrorBoundary>
      </Layout.Body>
    </Layout>
  )
}
